import React from 'react';
import ApplicationForm from '../components/ApplicationForm';
import '../styles/ApplicationForm.css';

const Apply = () => {
  return (
    <div className="application-wrapper">
      <ApplicationForm />
    </div>
  );
};

export default Apply;
